import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="inicio" className="relative flex min-h-[760px] h-screen items-center justify-center overflow-hidden bg-[#1A1A1A] px-5 text-white md:px-10" data-id="element-116">
      <motion.img initial={{
      scale: 1.08
    }} animate={{
      scale: 1
    }} transition={{
      duration: 11,
      ease: 'easeOut'
    }} src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=2200&q=90" alt="Interior contemporáneo de una vivienda" className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-117" />
      <div className="absolute inset-0 bg-black/40" data-id="element-118" />
      <motion.div initial={{
      opacity: 0,
      y: 34
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.25,
      duration: 0.8
    }} className="relative mx-auto flex w-full max-w-5xl flex-col items-center text-center" data-id="element-119">
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[.22em] text-[#e9c8b6]" data-id="element-120">
          Estudio de arquitectura · Montevideo
        </p>
        <h1 className="font-editorial text-5xl leading-[1.02] tracking-tight sm:text-6xl md:text-8xl" data-id="element-121">
          Espacios que inspiran.
          <br data-id="element-122" />
          Arquitectura que permanece.
        </h1>
        <p className="mt-7 max-w-md text-sm leading-6 text-white/85 md:text-base" data-id="element-123">
          Diseño arquitectónico residencial y comercial con identidad propia.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-3" data-id="element-124">
          <a href="#proyectos" className="bg-[#C4724A] px-6 py-3.5 text-xs font-bold uppercase tracking-wider transition-colors hover:bg-[#a95d3b]" data-id="element-125">
            Ver proyectos
          </a>
          <a href="#contacto" className="border border-white px-6 py-3.5 text-xs font-bold uppercase tracking-wider transition-colors hover:bg-white hover:text-[#1A1A1A]" data-id="element-126">
            Agendar consulta
          </a>
        </div>
      </motion.div>
    </section>;
}